import { useConfig } from '@/hooks'
import React from 'react'
import { Link } from 'react-router-dom'
import HtmlContent from '../HtmlContent'
import style from './styles/lecture.module.scss'

interface IProps {
  id: string | number
  image: string
  date: string
  title: string
  text: string
}

const LectureCard = ({
  id,
  image,
  date,
  title,
  text
}: IProps): React.ReactElement => {
  const config = useConfig()

  return (
    <Link
      to={`${config?.lecture}?element_id=${id}`}
      className={style.lecture__link}
    >
      <img
        src={image}
        width='560px'
        height='250px'
        alt={title}
        className={style.lecture__image}
      />

      <div className={style.lecture_content}>
        <span className={style.lecture__date}>{date}</span>
        <span className={style.lecture__title}>{title}</span>
        <HtmlContent content={text} className={style.lecture__text} />
      </div>
    </Link>
  )
}

export default LectureCard
